import { useQuery } from '@tanstack/react-query';
import { getJobHistory, getTaskHistory } from '../api';
import type { JobHistoryQuery } from '@maker-toolchest/shared';

export function useJobHistory(jobId: string, query?: JobHistoryQuery) {
  return useQuery({
    queryKey: ['jobHistory', jobId, query],
    queryFn: () => getJobHistory(jobId, query),
    enabled: !!jobId, // Only fetch when we have a valid jobId
  });
}

export function useTaskHistory(jobId: string, taskId: string) {
  return useQuery({
    queryKey: ['taskHistory', jobId, taskId],
    queryFn: () => getTaskHistory(jobId, taskId),
  });
}
